import React, { useEffect } from "react";

import { Button } from "react-bootstrap";

import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "src/routes";

import MoreInfoAMPBannerImg from "@assets/Images/MoreInfoAMPBannerImg.jpg";
import MoreInfoAMPBannerMobileImg from "@assets/Images/MoreInfoAMPBannerMobileImg.jpg";
import FAQAccordionGroup from "@components/component-library/Atoms/FAQAccordionGroup/FAQAccordionGroup";
import BannerTextAndButton from "@components/component-library/Molecules/BannerTextAndButton/BannerTextAndButton";
import BannerThreeToEightCols from "@components/component-library/Molecules/BannerThreeToEightCols/BannerThreeToEightCols";
import PublicPagesWrapper from "@components/component-library/Wrappers/PublicPagesWrapper";
import { useAuthenticationContext } from "@context/authentication";
import { FAQs } from "@util/FAQs";

import styles from "./MoreInfo.module.scss";

const AMP = () => {
  const { auth } = useAuthenticationContext();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PublicPagesWrapper className={styles["main-wrapper"]}>
        <div className={styles["card-image"]}>
          <div className={styles["image-container"]}>
            <img
              src={MoreInfoAMPBannerImg}
              alt="Banner image"
              className={classNames(styles["banner-image"], "d-none d-md-block")}
              height="561px"
            />
            <img
              src={MoreInfoAMPBannerMobileImg}
              alt="Banner image"
              className={classNames(styles["banner-image"], "d-md-none")}
            />
            <div className={styles["image-text"]}>
              <h1 className="d-none d-md-block mb-4">Art market professionals</h1>
              <h2 aria-level={1} className="d-md-none mb-4">
                Art market professionals
              </h2>
              <Button
                role="link"
                onClick={() => {
                  navigate(auth?.signInDetails?.loginId ? ROUTES.Dashboard.path : ROUTES.ExternalRegister.path);
                }}
                variant="secondary"
                className={styles["action-button"]}
                size="lg"
              >
                {auth?.signInDetails?.loginId ? "Dashboard" : "Register now"}
              </Button>
            </div>
          </div>
          <caption className="align-self-end text-end monoGrey1 b5 medium py-0">
            image credit: Jacobs Stock Photography Ltd
          </caption>
        </div>
        <div className="h3 mb-0">
          The scheme requires the seller to report all commercial resales of $1,000 or more. Sellers can report resales
          through an agent, such as an auction house, art dealer, or gallery (art market professionals). If you are a
          seller or a seller’s agent or a buyer or a buyer’s agent, you have a joint legal obligation to pay any royalty
          due.
        </div>
        <div className="py-5">
          <BannerThreeToEightCols
            heading="A royalty is payable on a reported resale if:"
            content={
              <div className="h3 mb-0">
                <p>
                  <ul>
                    <li className="mb-2">the work was acquired by the seller after 9 June 2010</li>
                    <li className="mb-2">the sale price (including GST) was $1,000 or more</li>
                    <li className="mb-2">the artist is living or, if deceased,</li>
                    <li className="mb-2">it is no more than 70 years from the end of the year of death</li>
                    <li className="mb-2">and their beneficiary meets the succession and residency tests</li>
                    <li className="mb-2">
                      the artist is from Australia; or if the artist is a citizen or national of one of the countries
                      that have been prescribed as reciprocating countries:
                      <ul className={classNames(styles["blank-bullets"], "mt-2")}>
                        <li className="mb-2">
                          as at 31 March 2024: Austria, Belgium, Czech Republic, Denmark, Finland, France, Germany,
                          Hungary, Ireland, Italy, Latvia, Netherlands, Norway, Portugal, Spain, Sweden, United Kingdom
                        </li>
                        <li className="mb-2">
                          and, as at 31 March 2025: Estonia, Greece, Lithuania, Mexico, New Zealand, Poland, Romania,
                          Slovakia and Uruguay
                        </li>
                      </ul>
                    </li>
                  </ul>
                </p>
              </div>
            }
          />
        </div>
        <p className="h3 mb-0">
          We currently do not collect for the following artists or their beneficiaries as they do not have the requisite
          connection to Australia or a reciprocating country:
          <ul>
            <li>Sam Fullbrook</li>
            <li>Clement Meadmore</li>
            <li>Percy Leason</li>
            <li>Gwyn Hanssen Pigott</li>
            <li>Robert Rooney</li>
          </ul>
        </p>
        <p className="h3 mb-0">
          You are still required to report resales for these artists. Please note as a beneficiary’s connection to
          Australia or a reciprocating country changes, artists can move in and out of eligibility for resale royalty.
        </p>
        <p className="h3 mb-0">To report resales to Copyright Agency, you need to register.</p>
        <div>
          <Button
            role="link"
            onClick={() => {
              navigate(auth?.signInDetails?.loginId ? ROUTES.Dashboard.path : ROUTES.ExternalRegister.path);
            }}
            variant="primary"
            size="lg"
          >
            {auth?.signInDetails?.loginId ? "Dashboard" : "Register now"}
          </Button>
        </div>
        <BannerTextAndButton
          bannerContent={
            <div className="monoBlack h4">
              <p>
                Looking for more information about the scheme? You’ll find the Code of Practice and a comprehensive
                guide to the scheme on the homepage.
              </p>
              <p>
                For a quick overview (including which artworks are covered and what information to report), refer to our
                quick guide for art market professionals.
              </p>
            </div>
          }
          buttonLabel="View the quick guide"
          href="/ART_MARKET_QUICK_GUIDE_2025.pdf"
        />
        <div className={styles["faq-wrapper"]}>
          <BannerThreeToEightCols heading="FAQs" content={<FAQAccordionGroup qnas={FAQs.amp} />} />
        </div>
      </PublicPagesWrapper>
    </div>
  );
};

export default AMP;
